// Use one collation locale for every UI language. The picker still displays
// native language names, but changing the active locale must not reorder them.
const languageLabelCollator = new Intl.Collator('en', {
    sensitivity: 'base',
    numeric: true,
});
/**
 * Sort using the native language name rendered in the picker, not an English
 * lookup table or the locale code. A fixed collator keeps that order stable
 * when the user changes the active UI language.
 */
export const sortLanguagePickerOptions = (options) => {
    return [...options].sort((left, right) => {
        const byDisplayName = languageLabelCollator.compare(left.label, right.label);
        if (byDisplayName !== 0)
            return byDisplayName;
        // Keep the base language code before its regional variants when they
        // share the same displayed language name, even when the base option has a
        // human-readable default region such as English (United States).
        const byRegionPresence = Number(left.code.includes('-')) - Number(right.code.includes('-'));
        if (byRegionPresence !== 0)
            return byRegionPresence;
        const byRegion = languageLabelCollator.compare(left.region || '', right.region || '');
        return byRegion || left.code.localeCompare(right.code);
    });
};
/**
 * Older context payloads do not include this setting, so language switching
 * remains enabled unless the backend explicitly disables it.
 */
export const isLanguagePickerEnabled = (context) => { var _a, _b; return ((_b = (_a = context === null || context === void 0 ? void 0 : context.appConfig) === null || _a === void 0 ? void 0 : _a.floor) === null || _b === void 0 ? void 0 : _b.showLanguagePicker) !== false; };
